import type { NavigateFunction } from 'react-router-dom'
import { emitToParent, isEmbedded } from './embed-bridge'

export const EMBED_CLOSED_ROUTE = '/embed/closed'

export type EmbedClosedState = { message?: string; returnTo?: string }

/**
 * Leave the meeting route for "somewhere else".
 *
 * At top level that is the dashboard, as it always was. In a frame it is not:
 * the dashboard is our app inside someone else's page, and for a guest it is a
 * login screen whose SecureID redirect cannot complete in a frame at all. So a
 * framed meeting stays on a small in-frame screen and tells the host, which
 * owns what happens next.
 */
export function exitMeetingRoute(
  navigate: NavigateFunction,
  opts: { reason: string; message?: string; replace?: boolean },
): void {
  if (!isEmbedded()) {
    navigate('/meetings', opts.replace ? { replace: true } : undefined)
    return
  }
  emitToParent('closed', { reason: opts.reason, ...(opts.message ? { message: opts.message } : {}) })
  const state: EmbedClosedState = {
    message: opts.message,
    returnTo: window.location.pathname.startsWith('/meeting/')
      ? window.location.pathname + window.location.search
      : undefined,
  }
  navigate(EMBED_CLOSED_ROUTE, { replace: true, state })
}
